import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {
  transform(value: number): string {
    const hours = Math.floor(value / 3600000);
    const minutes = Math.floor((value % 3600000) / 60000);
    const seconds = Math.floor((value % 60000) / 1000);
    const milliseconds = value % 1000;

    const hoursString = hours > 0 ? hours + 'h ' : '';
    const minutesString = minutes > 0 ? minutes + 'm ' : '';
    const secondsString = seconds > 0 ? seconds + 's ' : '';
    const millisecondsString = milliseconds > 0 ? milliseconds + 'ms' : milliseconds == 0 ? '0ms' : '';

    return `${hoursString}${minutesString}${secondsString}${millisecondsString}`;
  }
}
